module.exports = __webpack_public_path__ + "static/img/demo_profile.d1808de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dummy/demo_profile.png
// module id = NQDU
// module chunks = 150